import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import EventDetails from './components/EventDetails/EventDetails';
import Organizers from './Organizors/Organizor';
import ScrollToTop from './ScrollToTop';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <ScrollToTop/>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/event/:id" element={<EventDetails/>} />
        <Route path="/team" element={<Organizers/>} />
        
      </Routes>
    </Router>
);

